import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueCurrencyFilter from 'vue-currency-filter';
import {Eclipx, Router, Auth0, Auth0Guard, EUINotifications} from 'eclipx.ui';
import './styles/index.sass';
import routes from './router/Routes';
import {createProvider} from './vue-apollo';
import store from './store';
import DragonballApp from './DragonballApp';

Vue.config.productionTip = false;

// Install the base Eclipx UI plugin
Vue.use(Eclipx);
Vue.use(EUINotifications);

// Setup Routing with Eclipx UI Vue Router plugin and application routes
const router = Router(Vue, {routes});

// Setup Authentication with the Eclipx UI Auth0 plugin
Vue.use(Auth0, {
  domain: process.env.VUE_APP_AUTH_DOMAIN,
  clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
  connection: process.env.VUE_APP_AUTH_CONNECTION,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// Add Authentication redirection
router.beforeEach(Auth0Guard);

// Add Vuelidate for component form validation
Vue.use(Vuelidate);

// Filters
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
});

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: (h) => h(DragonballApp)
}).$mount('#app');
